module.exports = __webpack_public_path__ + "static/media/status-inativado.0a56ec36.svg";